import BaseModel from '@/data/models/BaseModel'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import { modelNames } from '@/data/models/types'
import type { McpPermission, McpTrustedBrand } from '@/services/domain/consent/types'
import { AttrField, OrmModel, StringField, DateField, BelongsToField, BooleanField } from 'vuex-orm-decorators'

@OrmModel(modelNames.CONNECTED_APP)
export default class ConnectedApp extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public clientName: string

  @AttrField([])
  public scopes: McpPermission[]

  @DateField()
  public connectedAt: Date

  @DateField()
  public lastUsedAt: Date

  @StringField()
  public connectedById: string

  @BelongsToField(UserPersonalInfo, 'connectedById')
  public connectedBy: UserPersonalInfo

  @BooleanField()
  public isCimd: boolean

  @BooleanField()
  public isTrusted: boolean

  @AttrField(null)
  public trustedLabel: string | null

  @AttrField(null)
  public trustedBrand: McpTrustedBrand | null

  @AttrField(null)
  public clientUrl: string | null

  @AttrField(null)
  public logoUrl: string | null
}
